import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import { fetchOrderAndGoods } from '../../Actions/getOrderAndGoods';
import { fetchTranslation } from '../../Actions/getTranslation';
import ProductsList from './ProductsList';
import RelatedProductsList from './RelatedProductsList';
import Loader from '../../components/Loader/Loader';
import s from './Catalog.module.scss';

const Catalog = props => {
  const { getOrderAndGoods, getTranslation, t, goods } = props;

  useEffect(() => {
    getOrderAndGoods();
    getTranslation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!Object.keys(goods).length || !t) return <Loader />;

  const goodsArr = R.filter(
    i => i.shop === 'cloud' && i.onSale === '1',
    R.values(goods)
  );

  const mainGoods = R.filter(i => i.main === '1', goodsArr);
  [mainGoods[0], mainGoods[1]] = [mainGoods[1], mainGoods[0]];

  const relatedGoods = R.filter(i => i.main !== '1', goodsArr);

  return (
    <div className={s.catalog}>
      <div className={s.products}>
        <ProductsList goods={mainGoods} />
      </div>
      <div className={s.relatedProductsMain}>
        <h3>{t['Дополнительные электроды, переходники и др.']}</h3>
        <div className={s.relatedProducts}>
          <RelatedProductsList goods={relatedGoods} />
        </div>
      </div>
    </div>
  );
};

Catalog.defaultProps = {
  getTranslation: PropTypes.func,
  getOrderAndGoods: PropTypes.func,
};

const mapStateToProps = state => ({
  t: state.translation,
  goods: state.goods
});

const mapDispatchToProps = {
  getTranslation: fetchTranslation,
  getOrderAndGoods: fetchOrderAndGoods
};

export default connect(mapStateToProps, mapDispatchToProps)(Catalog);
